import React from 'react';

type TabType = 'dashboard' | 'upcoming-dunning' | 'employees' | 'integrations' | 'customer-categories' | 'ap-archetypes' | 'governance-overlays' | 'customers' | 'customers-pse' | 'invoices';

interface OrganizationTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const OrganizationTabs: React.FC<OrganizationTabsProps> = ({ activeTab, onTabChange }) => {
  const tabs: { key: TabType; label: string }[] = [
    { key: 'dashboard', label: 'Dashboard' },
    { key: 'upcoming-dunning', label: 'Upcoming Dunning' },
    { key: 'employees', label: 'Employees' },
    { key: 'integrations', label: 'Integrations' },
    { key: 'customer-categories', label: 'Risk Profiles' },
    { key: 'ap-archetypes', label: 'AP Archetypes' },
    { key: 'governance-overlays', label: 'Governance Overlays' },
    { key: 'customers', label: 'All Customers' },
    { key: 'customers-pse', label: 'Credit Controlling Rubrics' },
    { key: 'invoices', label: 'Unpaid Invoices' }
  ];

  return (
    <div className="bg-white border-b border-gray-200">
      <nav className="flex space-x-4 px-2">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.key
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default OrganizationTabs;
